module.exports = __webpack_public_path__ + "img/p06.8838cf98.jpg";